import React from 'react';
import TopBar from './TopBar';
import ErrorMsg from './ErrorMsg';

const ErrorPage = ({ error }: { error: string }) => {
  return (
    <div id="error-page">
      <TopBar />
      <ErrorMsg error={error} />
    </div>
  );
};

export default ErrorPage;
